module.exports = __webpack_public_path__ + "static/media/devices-all.f9e7de5e.png";